import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
import ListingContext from '../../../../providers/Listing/Listing.context';
import InviteListingViewer from 'components/InviteListingViewer';
import { checkIsPrivate, getPrivateListingRoute, getResolveUrl } from 'utils';
import MailIcon from 'icons/Mail.icon';
import PlusIcon from 'icons/Plus.icon';
import LinkIcon from 'icons/Link.icon';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import AddLeadModal from 'components/AddLeadModal';

import './LeadsActions.styles.scss';
import './LeadsActions.styles.responsive.scss';

type LeadsActionsProps = {
  className?: string;
};

const LeadsActions: React.FC<LeadsActionsProps> = (props) => {
  const { className } = props;

  const [makeNewLeadModal, makeNewLeadModalRef] = useCallbackRef(null);
  const [inviteListingViewerModal, inviteListingViewerModalRef] =
    useCallbackRef(null);

  const { dealRoom, areActionsDisabled } = useContext(ListingContext);

  const classes = classNames('leads-actions', className);

  const isPrivate = checkIsPrivate(dealRoom?.listingStage);
  const listingId = dealRoom?.listingId;

  const { t } = useTranslation();

  const onInvitePrivate = useCallback(() => {
    makeNewLeadModal?.close();
    inviteListingViewerModal?.open();
  }, [inviteListingViewerModal, makeNewLeadModal]);

  const onAddLead = useCallback(() => {
    inviteListingViewerModal?.close();
    makeNewLeadModal?.open();
  }, [inviteListingViewerModal, makeNewLeadModal]);

  const copyToClipboard = useCopyToClipboard();

  return (
    <div className={classes}>
      {isPrivate && (
        <>
          <Button
            icon={LinkIcon}
            disabled={areActionsDisabled}
            onClick={(e) => {
              if (areActionsDisabled) return;
              copyToClipboard(
                e,
                getResolveUrl(getPrivateListingRoute(listingId)),
              );
            }}
          >
            {t('copyLink')}
          </Button>

          <Button
            icon={MailIcon}
            disabled={areActionsDisabled}
            onClick={() => {
              if (areActionsDisabled) return;
              inviteListingViewerModal?.open();
            }}
          >
            {t('invitePrivateViewer')}
          </Button>

          <InviteListingViewer
            ref={inviteListingViewerModalRef}
            isPrivate={isPrivate}
            listingId={listingId}
            onAddLead={onAddLead}
          />
        </>
      )}

      <Button
        icon={PlusIcon}
        disabled={areActionsDisabled}
        onClick={() => {
          if (areActionsDisabled) return;
          makeNewLeadModal?.open();
        }}
      >
        {t('addLead')}
      </Button>

      <AddLeadModal
        ref={makeNewLeadModalRef}
        dealRoom={dealRoom}
        onInvitePrivate={onInvitePrivate}
      />
    </div>
  );
};

export default LeadsActions;
